module.exports = __webpack_public_path__ + "media/newstyle/images/edit_document-8b49b7ecf7096fbdcc1a6f6a5f92a684.png";